import classNames from 'classnames';
import { useCallback } from 'react';
import { Button, Heading } from 'yoso';
import { QueryErrorBoundary } from '~/components/Error';
import { T } from '~/components/I18n';
import { MarketplaceExplorerCardList } from '~/components/Marketplace/Explorer/List/MarketplaceExplorerCardList';
import { MarketplaceExplorerTabs } from '~/components/Marketplace/Explorer/Nav/MarketplaceExplorerTabs';
import { useTab } from '~/components/Nav/Tab';
import { MarketplaceNftFallback } from '~/components/Nft/Marketplace/Fallback';
import styles from './MarketplaceExplorer.module.scss';

export type MarketplaceExplorerProps = {
  className?: string;
};
const urlMap = {
  '': `${import.meta.env.VITE_CITIZEN_STORE_URL}/marketplace`,
  CITIZEN: `${import.meta.env.VITE_CITIZEN_STORE_URL}/marketplace?collectibleId=1`,
  PET: `${import.meta.env.VITE_CITIZEN_STORE_URL}/marketplace?collectibleId=2`,
};
export const MarketplaceExplorer = ({ className }: MarketplaceExplorerProps) => {
  const { value, setValue } = useTab({
    name: 'marketplaceExplorerType',
    initialValue: '',
  });
  const handleTabClick = useCallback(
    (e) => {
      setValue(e.currentTarget.value);
    },
    [setValue]
  );
  return (
    <div className={classNames(styles.root, className)} data-event-category="item_c2c">
      <div className={styles.header}>
        <p className={styles.description}>
          <T name="citizen_challenge_section2_subtitle" />
        </p>
        <Heading level={4} className={styles.heading}>
          <T name="citizen_challenge_section2_title" />
        </Heading>
      </div>
      <MarketplaceExplorerTabs className={styles.tabs} value={value} onChange={handleTabClick} />
      <QueryErrorBoundary
        FallbackComponent={(props) => <MarketplaceNftFallback className={styles.body} {...props} />}
        resetKeys={[value]}>
        <div className={styles.body}>
          <MarketplaceExplorerCardList categoryType={value} />
        </div>
        <Button
          as="a"
          className={styles.button}
          size="large"
          block
          href={urlMap[value]}
          data-event="click"
          data-event-target="seeall_items_btn">
          <T name="citizen_button_title_seeall" />
        </Button>
      </QueryErrorBoundary>
    </div>
  );
};
